import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {CurrencyType, CurrencyTypeInput} from './currency-type.model';

export const loadCurrencyTypes = createAction(
  '[CurrencyType/API] Load CurrencyTypes',
  props<{ CurrencyTypes: CurrencyType[] }>()
);

export const addCurrencyType = createAction(
  '[CurrencyType/API] Add CurrencyType',
  props<{ CurrencyType: CurrencyType }>()
);

export const upsertCurrencyType = createAction(
  '[CurrencyType/API] Upsert CurrencyType',
  props<{ CurrencyType: CurrencyType }>()
);

export const addCurrencyTypes = createAction(
  '[CurrencyType/API] Add CurrencyTypes',
  props<{ CurrencyTypes: CurrencyType[] }>()
);

export const upsertCurrencyTypes = createAction(
  '[CurrencyType/API] Upsert CurrencyTypes',
  props<{ CurrencyTypes: CurrencyType[] }>()
);

export const updateCurrencyType = createAction(
  '[CurrencyType/API] Update CurrencyType',
  props<{ CurrencyType: Update<CurrencyType> }>()
);

export const updateCurrencyTypes = createAction(
  '[CurrencyType/API] Update CurrencyTypes',
  props<{ CurrencyTypes: Update<CurrencyType>[] }>()
);

export const deleteCurrencyType = createAction(
  '[CurrencyType/API] Delete CurrencyType',
  props<{ id: string }>()
);

export const deleteCurrencyTypes = createAction(
  '[CurrencyType/API] Delete CurrencyTypes',
  props<{ ids: string[] }>()
);

export const clearCurrencyTypes = createAction(
  '[CurrencyType/API] Clear CurrencyTypes'
);

// CUSTOM
export const createCurrencyType = createAction(
  '[CurrencyType/API] Create CurrencyType',
  props<{ input: CurrencyTypeInput }>()
);

export const editCurrencyType = createAction(
  '[CurrencyType/API] Edit CurrencyType',
  props<{ input: CurrencyTypeInput }>()
);

export const removeCurrencyType = createAction(
  '[CurrencyType/API] Remove CurrencyType',
  props<{ currencyUniqueId: string, id: string }>()
);

export const getCurrencyTypes = createAction(
  '[CurrencyType/API] get Currency Types',
  props<{instituionUniqueId:string}>()
);
